import React from "react";
import { Box, IconButton, Typography } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useHistory } from "react-router-dom";
import paths from "../routes/paths";

export default function NavBar(props) {
  const classes = styles();
  const history = useHistory();
  const { pathname } = history.location;

  const title = () => {
    switch (pathname) {
      case "/":
      case paths.MAIN:
      case "/prm-capodichino/":
        return "PRM";
      case paths.PRM_DETAILS:
        return "Dettaglio PRM";
      case paths.PRM_UPDATE:
        return "Aggiorna PRM";
      case paths.PRM_CREATE:
        return "Nuovo PRM";
      case paths.OPERATOR_DETAILS:
        return "Dettaglio Operatore";
      case paths.OPERATOR_ASSIGNMENT:
        return "Assegna Attività";
      default:
        return "";
    }
  };

  const isHome = () => {
    return (
      pathname === "/" ||
      pathname === paths.MAIN ||
      pathname === "/prm-capodichino/"
    );
  };

  const backIcon = () => {
    if (isHome()) {
      return <MenuIcon className={classes.icon} />;
    } else {
      return <ArrowBackIcon className={classes.icon} />;
    }
  };

  const iconPress = () => {
    if (isHome()) {
      //chiamata a container per tornare al menu
    } else {
      history.goBack();
    }
  };

  return (
    <Box
      display="flex"
      flexWrap="nowrap"
      flexDirection="row"
      className={classes.container}
    >
      <IconButton onClick={() => iconPress()}>{backIcon()}</IconButton>
      <Typography className={classes.title}>{title()}</Typography>
    </Box>
  );
}

const styles = makeStyles(theme => ({
  container: {
    //padding: 2,
    backgroundColor: theme.palette.primary.main,
    alignItems: "center"
  },
  title: {
    color: theme.palette.white,
    fontWeight: "500",
    fontSize: 18
  },
  icon: {
    color: theme.palette.white
  }
}));
